import React from 'react';
import { connect, useSelector } from 'react-redux';
import { generateLink, isMobile, urlFormatter } from '../../../util';
import Translation from 'services/translation.service';
import { Link } from 'react-router-dom';
import './HeaderNav.scss';
import JoinLebara from './StaticMenus/JoinLebara';
import JoinLebaraMobile from './StaticMenus/JoinLebaraMobile';
import Support from './StaticMenus/Support';
import MyLebara from './StaticMenus/MyLebara';
import BusinessMobile from './StaticMenus/BusinessMobile';
import RequirePermission from '../RequirePermission';
import { usePermissions } from 'contexts/core/PermissionsContext';
import { Helmet } from 'react-helmet';
import * as constants from '../../../constants';

const HeaderNav = (props) => {
  const { permissions } = usePermissions();

  const menu = [];
  let showArr = [];
  const headerMnu = props.menu;
  const { toggleSideMenu, links, changeLang, loggedIn } = props;
  const { iso } = useSelector((state) => state.layout);
  const subscriptionType = useSelector(
    (state) => state.dashboard.subscriptionType
  );
  const resetNavList = () => {
    const navList = document.getElementsByClassName('nav-list-lnk');
    const navListLength = navList.length;
    for (let i = 0; i < navListLength; i++) {
      navList[i].classList.remove('opened');
    }
  };

  const toggleNav = () => {
    if (isMobile()) {
      toggleSideMenu();
      resetNavList();
    }
  };

  const toggleNavMain = (e) => {
    if (isMobile()) {
      e.preventDefault();
      e.target.classList.toggle('opened');
    }
  };

  // Start create levels menu array
  if (headerMnu && headerMnu.length && permissions) {
    for (let mnuItem of headerMnu) {
      let haveChilds = mnuItem?.childs?.length;
      if (['Join Lebara', 'Services', 'الخدمات'].includes(mnuItem.title))
        continue;

      if (haveChilds) {
        let level2 = [];

        for (let mnuItemLevel2 of mnuItem.childs) {
          const level2HaveChilds =
            mnuItemLevel2.childs && mnuItemLevel2.childs.length > 0;

          // Check if the user has either "bundles" or "roaming" permission

          if (mnuItemLevel2.title.includes('Bundles for Existing Customers')) {
            if (!permissions.bundles && !permissions.roaming) {
              mnuItemLevel2.permission = 'hide';
              mnuItemLevel2.childs = mnuItemLevel2.childs.map((item) => {
                return {
                  ...item,
                  permission: 'bundles',
                };
              });
            } else if (permissions.bundles || permissions.roaming) {
              mnuItemLevel2.childs = mnuItemLevel2.childs.filter((item) => {
                if (item.url === '/build-your-bundle') {
                  item.permission = 'bundles_build_your_bundle';
                  return (
                    permissions.bundles && permissions.bundles_build_your_bundle
                  );
                  // Show "build_your_bundle" only if user has "bundles" permission
                } else if (item.url === '/find-your-bundle') {
                  item.permission = 'bundles_find_your_bundle';
                  return (
                    permissions.bundles && permissions.bundles_find_your_bundle
                  ); // Show "build_your_bundle" only if user has "bundles" permission
                } else if (item.title === 'Roaming') {
                  item.permission = 'roaming';
                  return permissions.roaming; // Show "roaming" only if user has "roaming" permission
                } else {
                  item.permission = 'bundles';
                  return true; // Show other items
                }
              });
              mnuItemLevel2.permission =
                mnuItemLevel2.childs.length === 0 ? 'hide' : 'show';
            }
          }
          // if (
          //   mnuItemLevel2.title.includes('Bundles for Existing Customers') &&
          //   !permissions.bundles &&
          //   !permissions.roaming
          // ) {
          //   mnuItemLevel2.permission = 'hide';
          // } else {
          //   // Filter child items based on permissions
          //   mnuItemLevel2.childs = mnuItemLevel2.childs.filter((item) => {
          //     if (item.permission === 'bundles_build_your_bundle') {
          //       return (
          //         permissions.bundles && permissions.bundles_build_your_bundle
          //       );
          //       // Show "build_your_bundle" only if user has "bundles" permission
          //     }
          //     if (item.permission === 'bundles_find_your_bundle') {
          //       return (
          //         permissions.bundles && permissions.bundles_find_your_bundle
          //       ); // Show "build_your_bundle" only if user has "bundles" permission
          //     }
          //     if (item.permission === 'roaming') {
          //       return permissions.roaming; // Show "roaming" only if user has "roaming" permission
          //     }
          //     return true; // Show other items
          //   });

          //   // Hide the section if no child items remain after filtering
          //   if (mnuItemLevel2.childs.length === 0) {
          //     mnuItemLevel2.permission = 'hide';
          //   } else {
          //     mnuItemLevel2.permission = 'show';
          //   }
          // }
          if (mnuItemLevel2?.url?.includes('/special-services')) {
            mnuItemLevel2.permission =
              !permissions.credit_transfer ||
              !permissions.special_services ||
              subscriptionType == constants.SUBSCRIPER_TYPE_POSTPAID
                ? 'hide'
                : 'show';
            if (!permissions.credit_transfer || !permissions.special_services) {
              mnuItemLevel2.childs = mnuItemLevel2.childs.map((item) => {
                return {
                  ...item,
                  permission: 'hide',
                };
              });
            } else {
              mnuItemLevel2.childs = mnuItemLevel2.childs.map((item) => {
                return {
                  ...item,
                  permission: 'show',
                };
              });
            }
            if (subscriptionType == constants.SUBSCRIPER_TYPE_POSTPAID)
              mnuItemLevel2.childs = [];
          }
          if (mnuItemLevel2?.url?.includes('/entertainment')) {
            mnuItemLevel2.permission = !permissions.entertainment
              ? 'hide'
              : 'show';
          }

          let level3 = [];
          if (level2HaveChilds) {
            level3 = mnuItemLevel2.childs
              .map((mnuItemLevel3) => {
                if (!mnuItemLevel3.url) return null;
                const generatedLink = generateLink(
                  mnuItemLevel3.url,
                  '',
                  Translation.key(mnuItemLevel3.title),
                  '',
                  toggleNav
                );
                return (
                  <RequirePermission
                    key={mnuItemLevel3.id}
                    permission={mnuItemLevel3.permission}
                  >
                    <div className="sub-nav-list-lnk">{generatedLink}</div>
                  </RequirePermission>
                );
              })
              .filter(Boolean);
          }

          if (level3.length > 0 || mnuItemLevel2.url) {
            let generatedLink = generateLink(
              mnuItemLevel2.url,
              'sub-nav-title',
              Translation.key(mnuItemLevel2.title),
              '',
              toggleNav
            );
            showArr.push(mnuItemLevel2.permission);
            const isMoreThanFive = level3.length > 5;

            level2.push(
              <RequirePermission permission={mnuItemLevel2.permission}>
                <div
                  key={mnuItemLevel2.id}
                  className={`nav-section mt-20 ${
                    !mnuItemLevel2.permission
                      ? 'flex-25 width-450'
                      : 'flex-25 width-250'
                  }`}
                >
                  {generatedLink}
                  <div
                    className="nav-section nav-section-column test"
                    style={
                      isMoreThanFive
                        ? { display: 'grid', gridTemplateColumns: '1fr 1fr' }
                        : {}
                    }
                  >
                    {mnuItemLevel2.title === 'Entertainment'
                      ? level3.slice(0, 2)
                      : level3}
                    {mnuItemLevel2.title === 'Entertainment' &&
                      (!localStorage.getItem('loggedIn') ||
                        permissions.entertainment) && (
                        <div className="sub-nav-list-lnk">
                          <Link
                            to={{ pathname: urlFormatter(mnuItemLevel2.url) }}
                            className="underline"
                          >
                            {Translation.key('generic_lbl_view_all')}
                          </Link>
                        </div>
                      )}
                  </div>
                </div>
              </RequirePermission>
            );
          }
        }

        if (level2.length > 0) {
          const showCount = showArr.filter((item) => item === 'show').length;

          menu.push(
            <li className="nav-list-itm border-bottom" key={mnuItem.id}>
              <div className="nav-list-lnk pointer" onClick={toggleNavMain}>
                {Translation.key(mnuItem.title)}
              </div>
              <div className="sub-nav-wrapper">
                <div
                  className="sub-nav"
                  style={
                    showCount > 1
                      ? {
                          gap: '64px',
                        }
                      : {}
                  }
                >
                  <div
                    className="back mobile-tablet-only"
                    onClick={resetNavList}
                  >
                    <svg
                      width="10"
                      height="18"
                      viewBox="0 0 10 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 17L1.00016 9.00048L9 1.00048"
                        stroke="#7C8095"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <span>{Translation.key(mnuItem.title)}</span>
                  </div>
                  {level2}
                </div>
              </div>
            </li>
          );
        }
      } else {
        let generatedLink = generateLink(
          mnuItem.url,
          'nav-list-lnk',
          mnuItem.title,
          '',
          toggleSideMenu
        );
        menu.push(
          <li className="nav-list-itm" key={mnuItem.id}>
            {generatedLink}
          </li>
        );
      }
    }
  }

  let complaint_link = '';
  let stores_link = '';
  let careers_link = '';
  let business_link = '';
  if (links) {
    complaint_link = urlFormatter(
      links['informative-customer_complaints']['route']
    );
    stores_link = urlFormatter(links['informative-stores']['route']);
    careers_link = urlFormatter(links['informative-careers']['route']);
    business_link = urlFormatter(links['informative-business']['route']);
  }

  return (
    <nav className="header-nav">
      {loggedIn && (
        <MyLebara
          toggleNav={toggleNav}
          toggleNavMain={toggleNavMain}
          resetNavList={resetNavList}
        />
      )}
      <ul className="header-nav-list">
        <JoinLebara />
        <JoinLebaraMobile
          toggleNav={toggleNav}
          toggleNavMain={toggleNavMain}
          resetNavList={resetNavList}
        />
        {menu}
        <Support
          toggleNav={toggleNav}
          toggleNavMain={toggleNavMain}
          resetNavList={resetNavList}
        />
        <li className="nav-list-itm mobile-tablet-only">
          <a onClick={changeLang} className="nav-list-lnk light-blue">
            {Translation.key('switch_language_label')}
          </a>
        </li>
        <BusinessMobile
          toggleNav={toggleNav}
          toggleNavMain={toggleNavMain}
          resetNavList={resetNavList}
        />
        <li className="nav-list-itm hide-complaint">
          <Link className="nav-list-lnk" to={business_link}>
            {Translation.key('b2b_business')}
          </Link>
        </li>
        <li className="nav-list-itm hide-complaint">
          <Link className="nav-list-lnk" to={complaint_link}>
            {Translation.key('Complaints')}
          </Link>
        </li>
        <li className="nav-list-itm hide-complaint">
          <Link className="nav-list-lnk" to={stores_link}>
            {Translation.key('shop_finder')}
          </Link>
        </li>
        <li className="nav-list-itm hide-complaint">
          <Link className="nav-list-lnk" to={careers_link}>
            {Translation.key('careers')}
          </Link>
        </li>
        <li className="nav-list-itm hide-complaint">
          <Link className="nav-list-lnk">
            {Translation.key('switch_language_label')}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.user.loggedIn,
    menu: state.menu.headerMenu,
    userInfo: state.user.userInfo,
    links: state.layout.routes,
  };
};

export default connect(mapStateToProps)(HeaderNav);
